export default "__VITE_ASSET__DQ1VSPlj__"